<div [appStoryblok]="_editable" [@changeAnimation]="animationState">
  {{ _message }}
</div>
